import React from 'react';
import { NavLink } from 'react-router-dom';

const LINKS = [
    { to: '/', label: 'Command Center', end: true },
    { to: '/runs', label: 'Extract Runs' },
    { to: '/analytics', label: 'Analytics' },
    { to: '/jobs', label: 'Jobs' }
];

function NavBar() {
    return (
        <nav className="nav-bar">
            <NavLink to="/" className="nav-brand" aria-label="Mission Control home">
                <img src="/favicon.svg" alt="" />
                <span>Mission Control</span>
            </NavLink>
            <div className="nav-links">
                {LINKS.map(({ to, label, end }) => (
                    <NavLink key={to} to={to} end={end} className="nav-link">
                        {label}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}

export default NavBar;
